import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-4 pb-10',
    link: 'font-bold'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
